export const environment = {
  production: true,
  apiUrl: 'https://loop-dev-ukwest-explorer-api.azurewebsites.net/api',
  auth0Domain: 'loop-dev.uk.auth0.com',
  auth0ClientId: 'OI5nA7orZeWyeFmBliYP0NhrPhF61PKA',
  auth0Audience: 'https://xray.loop.software/api',
};
